(function(){
  const ENDPOINT_URL = "https://script.google.com/macros/s/AKfycbxnrAjMnCLBa3zQTVT6dOxuKfU6nksaX0r9TZ3Tu8tLDZAyfDtGi-XXC2GiHyAcdrOT/exec";
  const CONTRACT_PAGE_PATH = "/pages/aceite-contrato";

  const $ = (id) => document.getElementById(id);

  function getStoredValue(key){
  try {
    return localStorage.getItem(key) || sessionStorage.getItem(key) || "";
  } catch(e){
    return "";
  }
}

function parseTrackingTime(value){
  if (!value) return 0;

  const raw = String(value).trim();

  // timestamp em ms
  if (/^\d{13}$/.test(raw)) return Number(raw);

  // timestamp em segundos
  if (/^\d{10}$/.test(raw)) return Number(raw) * 1000;

  // data ISO ou texto parseável
  const t = Date.parse(raw);
  return Number.isFinite(t) ? t : 0;
}

function getFreshTrackingValue(valueKey, timeKey, maxAgeHours){
  const value = String(getStoredValue(valueKey) || "").trim();
  const timeRaw = String(getStoredValue(timeKey) || "").trim();

  if (!value) return "";

  const t = parseTrackingTime(timeRaw);

  // Se não tem timestamp confiável, descarta.
  if (!t) return "";

  const ageMs = Date.now() - t;
  const maxMs = maxAgeHours * 60 * 60 * 1000;

  // Se veio do futuro ou passou da janela, descarta.
  if (ageMs < 0 || ageMs > maxMs) return "";

  return value;
}

function getFreshTrackingTime(timeKey, maxAgeHours){
  const timeRaw = String(getStoredValue(timeKey) || "").trim();
  const t = parseTrackingTime(timeRaw);

  if (!t) return "";

  const ageMs = Date.now() - t;
  const maxMs = maxAgeHours * 60 * 60 * 1000;

  if (ageMs < 0 || ageMs > maxMs) return "";

  return timeRaw;
}

  function setStatus(text, type){
    const statusEl = $("arbo_status");
    if (!statusEl) return;
    statusEl.textContent = text || "";
    statusEl.className = "arbo-status " + (type || "neutral");
  }

  function showLoading(on){
    const el = $("arbo_loading");
    if (el) el.style.display = on ? "inline" : "none";
  }

  function sanitizeOrderId(v){
    return String(v || "").trim().replace(/[^a-zA-Z0-9_-]/g, "").slice(0, 30).toUpperCase();
  }

  function onlyDigits(v){ return String(v || "").replace(/\D/g,""); }

  // aceita "2000", "2.000", "2.000,00", "2000,50", "2000.50"
  function brlToReaisNumber(input){
    let s = String(input || "").trim();
    if (!s) return null;
    s = s.replace(/[R$\s]/g, "").replace(/[^\d.,-]/g, "");
    if (!s) return null;

    if (s.includes(",")) s = s.replace(/\./g, "").replace(",", ".");
    else if (s.includes(".")) {
      const parts = s.split(".");
      const last = parts[parts.length - 1];
      if (last.length === 3) s = parts.join(""); // milhar
    }

    const num = Number(s);
    if (!Number.isFinite(num) || num <= 0) return null;
    return Math.round(num * 100) / 100;
  }

  function makeToken(){
    const a = Math.random().toString(36).slice(2, 10).toUpperCase();
    const b = Date.now().toString(36).toUpperCase();
    return (b + a).replace(/[^A-Z0-9]/g,"").slice(0,24);
  }

  function buildContractLink(order_id, token){
    const base = window.location.origin;
    const url = new URL(base + CONTRACT_PAGE_PATH);
    url.searchParams.set("order_id", order_id);
    url.searchParams.set("t", token);
    return url.toString();
  }

  function buildMessage(link, order_id){
    return `Oi! Para finalizar o seu pedido ${order_id}, revise o anexo e confirme o aceite do contrato aqui:
${link}

Leva menos de 1 minuto. Obrigado!`;
  }

  // CEP máscara
  function maskCEP(el){
    if (!el) return;
    el.addEventListener("input", () => {
      let v = onlyDigits(el.value).slice(0,8);
      if (v.length > 5) v = v.slice(0,5) + "-" + v.slice(5);
      el.value = v;
    });
  }

  // Nascimento máscara DD/MM/AAAA
  function maskNascimento(el){
    if (!el) return;
    el.addEventListener("input", () => {
      let v = onlyDigits(el.value).slice(0,8);
      if (v.length >= 5) v = v.slice(0,2) + "/" + v.slice(2,4) + "/" + v.slice(4);
      else if (v.length >= 3) v = v.slice(0,2) + "/" + v.slice(2);
      el.value = v;
    });
  }

  // CPF/CNPJ máscara
  function maskCpfCnpj(el){
    if (!el) return;
    el.addEventListener("input", () => {
      let v = onlyDigits(el.value).slice(0,14);

      if (v.length <= 11) {
        // CPF
        v = v.replace(/(\d{3})(\d)/,'$1.$2')
             .replace(/(\d{3})(\d)/,'$1.$2')
             .replace(/(\d{3})(\d{1,2})$/,'$1-$2');
      } else {
        // CNPJ
        v = v.replace(/^(\d{2})(\d)/,'$1.$2')
             .replace(/^(\d{2})\.(\d{3})(\d)/,'$1.$2.$3')
             .replace(/\.(\d{3})(\d)/,'.$1/$2')
             .replace(/(\d{4})(\d)/,'$1-$2');
      }

      el.value = v;
    });
  }

  // Telefone BR máscara (com/sem 55)
  function maskPhoneBR(el){
    if (!el) return;

    const run = () => {
      let v = onlyDigits(el.value);

      // remove 55 se vier junto
      if (v.startsWith("55") && v.length > 11) v = v.slice(2);

      v = v.slice(0, 11);

      if (v.length <= 2) { el.value = v ? `(${v}` : ""; return; }

      const ddd = v.slice(0,2);
      const rest = v.slice(2);

      if (rest.length <= 4) { el.value = `(${ddd}) ${rest}`; return; }

      if (v.length <= 10) {
        // 8 dígitos
        const p1 = rest.slice(0,4);
        const p2 = rest.slice(4,8);
        el.value = `(${ddd}) ${p1}${p2 ? "-" + p2 : ""}`;
        return;
      }

      // 9 dígitos
      const p1 = rest.slice(0,5);
      const p2 = rest.slice(5,9);
      el.value = `(${ddd}) ${p1}${p2 ? "-" + p2 : ""}`;
    };

    el.addEventListener("input", run);
    el.addEventListener("keyup", run);
    el.addEventListener("change", run);
    el.addEventListener("paste", () => setTimeout(run, 0));
  }

  // ViaCEP
  async function buscarCep(cep) {
    const clean = onlyDigits(cep);
    if (clean.length !== 8) return null;
    try {
      const r = await fetch(`https://viacep.com.br/ws/${clean}/json/`);
      const d = await r.json();
      if (d && !d.erro) return d;
      return null;
    } catch (e) { return null; }
  }

  function setupViaCep(){
    const cepEl = $("arbo_cep");
    const enderecoEl = $("arbo_endereco");
    const bairroEl   = $("arbo_bairro");
    const cidadeEl   = $("arbo_cidade");
    const estadoEl   = $("arbo_estado");

    if (!cepEl) return;

    cepEl.addEventListener("blur", async () => {
      setStatus("", "neutral");
      const d = await buscarCep(cepEl.value);
      if (!d) {
        setStatus("CEP não localizado. Preencha o endereço manualmente para continuar.", "err");
        return;
      }
      if (enderecoEl) enderecoEl.value = d.logradouro || "";
      if (bairroEl)   bairroEl.value   = d.bairro || "";
      if (cidadeEl)   cidadeEl.value   = d.localidade || "";
      if (estadoEl)   estadoEl.value   = (d.uf || "").toUpperCase();
      setStatus("Endereço preenchido automaticamente (você pode ajustar se necessário).", "ok");
    });
  }

  // POST por iframe (sem CORS)
  function postViaIframe(payload){
    return new Promise((resolve) => {
      const iframe = document.createElement("iframe");
      iframe.name = "arbo_iframe_" + Date.now();
      iframe.style.display = "none";
      document.body.appendChild(iframe);

      const f = document.createElement("form");
      f.method = "POST";
      f.action = ENDPOINT_URL;
      f.target = iframe.name;

      Object.entries(payload).forEach(([k,v]) => {
        const i = document.createElement("input");
        i.type="hidden"; i.name=k; i.value = v ?? "";
        f.appendChild(i);
      });

      document.body.appendChild(f);

      const cleanup = () => {
        try { document.body.removeChild(f); } catch(e){}
        try { document.body.removeChild(iframe); } catch(e){}
      };

      iframe.onload = () => { cleanup(); resolve(true); };

      f.submit();

      setTimeout(() => { cleanup(); resolve(true); }, 2000);
    });
  }

  async function copyToClipboard(text){
    try { await navigator.clipboard.writeText(text); return true; }
    catch(e){
      const ta=document.createElement("textarea");
      ta.value=text; document.body.appendChild(ta); ta.select();
      try { document.execCommand("copy"); document.body.removeChild(ta); return true; }
      catch(err){ document.body.removeChild(ta); return false; }
    }
  }

async function onGerar(){
  try{
    setStatus("", "neutral");

    const unidadeEl = $("arbo_unidade");
    const orderEl   = $("arbo_order_id");
    const valorEl   = $("arbo_valor");
    const origemEl  = $("arbo_origem");
    const pdfEl     = $("arbo_pdf_url");

    const nomeEl = $("arbo_nome");
    const emailEl = $("arbo_email");
    const telEl = $("arbo_tel");
    const cpfEl = $("arbo_cpf");
    const nascEl = $("arbo_nascimento");

    const cepEl = $("arbo_cep");
    const numeroEl = $("arbo_numero");
    const endEl = $("arbo_endereco");
    const bairroEl = $("arbo_bairro");
    const cidadeEl = $("arbo_cidade");
    const ufEl = $("arbo_estado");
    const compEl = $("arbo_complemento");

    const createAsanaEl = $("arboCreateAsana"); // 👈 ADICIONADO

    const linkOut = $("arbo_link");
    const msgOut  = $("arbo_msg");

    const unidade  = String(unidadeEl?.value || "").trim().toLowerCase();
    const order_id = sanitizeOrderId(orderEl?.value);
    const reaisNum = brlToReaisNumber(valorEl?.value);
    const origem = String(origemEl?.value || "").trim();
    const pdf_url = String(pdfEl?.value || "").trim();

    const nome = String(nomeEl?.value || "").trim();
    const email = String(emailEl?.value || "").trim();
    const phone = String(telEl?.value || "").trim();
    const cpf = String(cpfEl?.value || "").trim();
    const nascimento = String(nascEl?.value || "").trim();

    const cep = String(cepEl?.value || "").trim();
    const numero = String(numeroEl?.value || "").trim();
    const endereco = String(endEl?.value || "").trim();
    const bairro = String(bairroEl?.value || "").trim();
    const cidade = String(cidadeEl?.value || "").trim();
    const estado = String(ufEl?.value || "").trim().toUpperCase();
    const complemento = String(compEl?.value || "").trim();

    // Janela curta para impedir reaproveitamento de clique antigo.
    // Recomendo 24h. Se quiser ser ainda mais conservador: 6h.

    // Removido para corrigir erro de captura do gclid do vendedor
    //const GOOGLE_CLICK_MAX_AGE_HOURS = 24;

    //const gclid = getFreshTrackingValue("arb_gclid", "arb_gclid_at", GOOGLE_CLICK_MAX_AGE_HOURS);
    //const wbraid = getFreshTrackingValue("arb_wbraid", "arb_wbraid_at", GOOGLE_CLICK_MAX_AGE_HOURS);
    //const gbraid = getFreshTrackingValue("arb_gbraid", "arb_gbraid_at", GOOGLE_CLICK_MAX_AGE_HOURS);

    //const gclid_at = gclid ? getFreshTrackingTime("arb_gclid_at", GOOGLE_CLICK_MAX_AGE_HOURS) : "";
    //const wbraid_at = wbraid ? getFreshTrackingTime("arb_wbraid_at", GOOGLE_CLICK_MAX_AGE_HOURS) : "";
    //const gbraid_at = gbraid ? getFreshTrackingTime("arb_gbraid_at", GOOGLE_CLICK_MAX_AGE_HOURS) : "";

    //const gad_source = (gclid || wbraid || gbraid) ? getStoredValue("arb_gad_source") : "";

    //const fbc = getStoredValue("_arbo_fbc");
    //const fbp = getStoredValue("_arbo_fbp");

    if (!unidade)  { setStatus("Selecione a unidade.", "err"); unidadeEl?.focus(); return; }
    if (!order_id) { setStatus("Preencha o ID do pedido.", "err"); orderEl?.focus(); return; }
    if (reaisNum === null) { setStatus("Preencha um valor válido (ex: 8.450,00).", "err"); valorEl?.focus(); return; }
    if (!pdf_url || !/^https?:\/\//i.test(pdf_url)) { setStatus("Cole um link válido do PDF (Drive).", "err"); pdfEl?.focus(); return; }

    if (!nome) { setStatus("Preencha o nome do cliente.", "err"); nomeEl?.focus(); return; }
    if (!email || !email.includes("@")) { setStatus("Email inválido.", "err"); emailEl?.focus(); return; }
    if (onlyDigits(phone).length < 10) { setStatus("Telefone inválido.", "err"); telEl?.focus(); return; }
    if (onlyDigits(cpf).length !== 11 && onlyDigits(cpf).length !== 14) { setStatus("CPF/CNPJ inválido.", "err"); cpfEl?.focus(); return; }

    const cpfCnpjDigits = onlyDigits(cpf);

    // CPF = 11 dígitos -> nascimento obrigatório
    if (cpfCnpjDigits.length === 11) {
      if (onlyDigits(nascimento).length !== 8) {
        setStatus("Data de nascimento é obrigatória para CPF (DD/MM/AAAA).", "err");
        nascEl?.focus();
        return;
      }
    }

    // CNPJ = 14 dígitos -> nascimento opcional
    if (cpfCnpjDigits.length === 14) {
      if (nascimento && onlyDigits(nascimento).length > 0 && onlyDigits(nascimento).length !== 8) {
        setStatus("Se preencher a data para CNPJ, use o formato DD/MM/AAAA.", "err");
        nascEl?.focus();
        return;
      }
    }

    if (onlyDigits(cep).length !== 8) { setStatus("CEP inválido.", "err"); cepEl?.focus(); return; }
    if (!numero) { setStatus("Número é obrigatório.", "err"); numeroEl?.focus(); return; }
    if (!endereco || !bairro || !cidade || estado.length !== 2) { setStatus("Endereço incompleto (confira CEP/UF).", "err"); return; }

    showLoading(true);

    // 👇 CAPTURA O CHECKBOX
    const create_asana = createAsanaEl?.checked ? "1" : "0";

    // 1) token + link
    const token = makeToken();
    const link = buildContractLink(order_id, token);
    if (linkOut) linkOut.value = link;
    if (msgOut)  msgOut.value = buildMessage(link, order_id);

    // 2) registra token no Apps Script
    await postViaIframe({
      action: "create_token_v2",
      token,
      order_id,
      unidade,
      value: String(reaisNum),

      phone,
      nome,
      cpf,
      nascimento,
      email,
      cep,
      endereco,
      numero,
      bairro,
      cidade,
      estado,
      complemento,
      pdf_url,
      origem,
      // Removido para corrigir erro de captura do gclid do vendedor
      //gclid,
      //wbraid,
      //gbraid,
      //gclid_at,
      //wbraid_at,
      //gbraid_at,
      //gad_source,
      //fbc,
      //fbp,

      create_asana // 👈 ENVIANDO PARA O APPS SCRIPT
    });

    setStatus("Link gerado e registrado. ✅", "ok");

  } catch (e) {
    setStatus("Link gerado, mas houve falha ao registrar internamente: " + (e?.message || String(e)), "err");
  } finally {
    showLoading(false);
  }
}

  function init(){
    if (window.location.pathname !== "/pages/gerador-de-link-completo") return;

    // máscaras + CEP
    maskCEP($("arbo_cep"));
    maskNascimento($("arbo_nascimento"));
    maskCpfCnpj($("arbo_cpf"));
    maskPhoneBR($("arbo_tel"));
    setupViaCep();

    // botões
    const btnGerar = $("arbo_btnGerar");
    const btnCopiar = $("arbo_btnCopiar");
    const btnCopiarMsg = $("arbo_btnCopiarMsg");

    btnGerar?.addEventListener("click", (e)=>{ e.preventDefault(); onGerar(); });

    btnCopiar?.addEventListener("click", async (e)=>{
      e.preventDefault();
      const v = ($("arbo_link")?.value || "").trim();
      if (!v) return setStatus("Gere o link primeiro.", "err");
      const ok = await copyToClipboard(v);
      setStatus(ok ? "Link copiado." : "Não foi possível copiar.", ok ? "ok" : "err");
    });

    btnCopiarMsg?.addEventListener("click", async (e)=>{
      e.preventDefault();
      const v = ($("arbo_msg")?.value || "").trim();
      if (!v) return setStatus("Gere o link primeiro.", "err");
      const ok = await copyToClipboard(v);
      setStatus(ok ? "Mensagem copiada." : "Não foi possível copiar.", ok ? "ok" : "err");
    });

    setStatus("Pronto. Preencha e clique em “Gerar link”.", "neutral");
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();